// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.82.1-beta.2c675fee',
  revision: '2c675fee',
  branch: 'develop',
  date: 'Mon, 15 Dec 2025 21:18:04 GMT'
};